module.exports = __webpack_public_path__ + "static/img/vip.1291de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vip.png
// module id = 6A7S
// module chunks = 1